module.exports = __webpack_public_path__ + "img/bg-handwrite.5793a952.jpg";